module.exports = __webpack_public_path__ + "img/单词@3x.5aa7ef10.png";